interface DataType {
  id: number;
  page: string;
  title: string;
  desc: React.ReactNode;
}

const faq_data: DataType[] = [
  // {
  //   id: 1,
  //   page: "home_1",
  //   title: "How to buy FOX tokens?",
  //   desc: "It's very simple! Register here. In your personal account, create a wallet where you can store your FOX tokens. Then just send any amount to the displayed address in your office.",
  // },
  // {
  //   id: 2,
  //   page: "home_1",
  //   title: "What is the value of FOX tokens?",
  //   desc: "It's very simple! Register here. In your personal account, create a wallet where you can store your FOX tokens. Then just send any amount to the displayed address in your office.",
  // },
  {
    id: 1,
    page: "home_2",
    title: "What is BitPrimax technology?",
    desc: "BitPrimax is a secure and user-friendly platform designed to allow individuals to buy, sell, and exchange cryptocurrencies. Whether you're new to digital assets or an experienced trader, BitPrimax offers a range of tools to manage and grow your portfolio.",
  },
  {
    id: 2,
    page: "home_2",
    title: "What cryptocurrencies can I trade on BitPrimax?",
    desc: "We support a wide variety of popular cryptocurrencies, including Bitcoin (BTC), Tether (USDT), BNB (BNB), USD Coin (USDC), and many others. Check our asset list for an up-to-date list of all available digital currencies.",
  },
  {
    id: 2.5,
    page: "home_2",
    title: "What blockchains are supported on BitPrimax?",
    desc: "At the moment we only support tradding on Binance Smart Chain (BSC) which is currently considered the most popular chain. We are working to include other blockchains in the near future.",
  },
  {
    id: 3,
    page: "home_2",
    title: "How do I create an account?",
    desc: "Creating an account on BitPrimax is easy! Simply click the 'Sign Up' or 'Get Started' button, provide your email, set a strong password, and optionally complete the identity verification process for added security. Once your account is set up, you can begin trading immediately.",
  },
  {
    id: 4,
    page: "home_2",
    title: "Is BitPrimax secure?",
    desc: "Yes, security is our top priority. We implement industry-standard encryption, two-factor authentication (2FA), and cold storage solutions to ensure your funds and personal information remain protected at all times.",
  },
  {
    id: 5,
    page: "home_2",
    title: "How do I withdraw funds?",
    desc: "Withdrawing funds from BitPrimax is simple. Just navigate to the 'Naira Wallet' section from the Dashboard, Click 'Withdraw', enter the amount you wish to withdraw, and select the bank account to withdraw funds to. Once you submit and the transaction is confirmed, your funds will be to credited to your bank instantly.",
  },
  {
    id: 6,
    page: "home_2",
    title: "What are the fees on BitPrimax?",
    desc: (
      <>
        Our fee structure is transparent and competitive. We charge Zero
        transaction fees for trades, withdrawals, and transfers executed by new
        users in the first 60 days. We only charge a flat N100 fee for
        withdrawals but only after your first 60 days, and there are no extra
        hidden charges or fees.
      </>
    ),
  },
  // {
  //   id: 7,
  //   page: "home_2",
  //   title: "How do I contact BitPrimax support?",
  //   desc: "Our customer support team is available 24/7 to assist you with any questions or concerns. You can reach us via email (support@bitprimax.com), or live chat, and we'll be happy to help you with any issues you may encounter.",
  // },
  // {
  //   id: 8,
  //   page: "home_2",
  //   title: "Can I trust BitPrimax with my funds?",
  //   desc: `
  //   Absolutely! BitPrimax is a
  //   ${
  //     "" // licensed and regulated | secure and reliable | trusted and reputable
  //   }
  //   secure and reliable
  //   cryptocurrency exchange that adheres to strict security protocols to protect your funds. We have a proven track record of providing a safe and reliable trading environment for our users.
  //   `,
  // },
  // {
  //   id: 9,
  //   page: "home_2",
  //   title: "How do I reset my password?",
  //   desc: "If you've forgotten your password, you can easily reset it by clicking the 'Forgot Password' link on the login page. Enter your email address, follow the instructions in the email we send you, and create a new password to regain access to your account. If you continue to have issues, simple contact us at support@bitprimax.com",
  // },
  {
    id: 10,
    page: "home_2",
    title: "What is the BitPrimax referral program?",
    desc: "Our referral program allows you to earn rewards for inviting friends to join BitPrimax. When someone signs up using your unique referral link and completes a trade, you'll receive a commission on their trading fees. The more friends you refer, the more you can earn!",
  },
  // {
  //   id: 11,
  //   page: "home_2",
  //   title: "How do I verify my account?",
  //   desc: "To verify your account, you'll need to provide some basic information about yourself, such as your name, address, and date of birth. You'll also need to upload a copy of your government-issued ID and a selfie to confirm your identity. Once your documents are verified, your account will be fully verified and you can start trading.",
  // },
  // {
  //   id: 12,
  //   page: "home_2",
  //   title: "What is the BitPrimax mobile app?",
  //   desc: "The BitPrimax mobile app is a convenient way to trade cryptocurrencies on the go. With the app, you can buy, sell, and exchange digital assets from your smartphone or tablet. The app is available for both iOS and Android devices and offers all the features of the web platform in a user-friendly mobile interface.",
  // },
  // {
  //   id: 13,
  //   page: "home_2",
  //   title: "How do I deposit funds into my BitPrimax account?",
  //   desc: "Depositing funds into your BitPrimax account is easy. Just navigate to the wallet section of the dashboard, select the currency you want to deposit, and click the 'Deposit' button. You'll be provided with a wallet address to send your funds to. Once the transaction is confirmed, your funds will be credited to your account.",
  // },
  // {
  //   id: 14,
  //   page: "home_2",
  //   title: "What is the BitPrimax trading platform?",
  //   desc: "The BitPrimax trading platform is a powerful tool that allows you to buy, sell, and exchange cryptocurrencies with ease. The platform offers advanced charting tools, real-time market data, and a range of order types to help you make informed trading decisions. Whether you're a beginner or an experienced trader, the BitPrimax trading platform has everything you need to succeed in the crypto market.",
  // },
  {
    id: 15,
    page: "home_2",
    title: "How do I Sell Crypto on BitPrimax?",
    desc: (
      <>
        Selling Crypto on BitPrimax is simple. Just login, navigate to the
        trading section, select the network/chain (e.g Binance Smart Chain) and
        coin (eg. Bitcoin) from the list of available cryptocurrencies, and
        enter the amount you want to sell. Confirm the exchange rate and value
        to recieve then click next. Select the checkboxes to ensure you
        understand our trading terms and conditions and then click on next. Send
        the coin to the address provided on the screen. Immediatedly the
        transaction is confirmed, your &lsquo;Naira Fiat wallet&lsquo; will be
        instantly credited.
      </>
    ),
  },
  // {
  //   id: 16,
  //   page: "home_2",
  //   title: "What is the BitPrimax affiliate program?",
  //   desc: "The BitPrimax affiliate program allows you to earn commissions by referring new users to the platform. When someone signs up using your unique affiliate link and completes a trade, you'll receive a commission on their trading fees. The more users you refer, the more you can earn. It's a great way to earn passive income by promoting BitPrimax to your friends, family, and followers.",
  // },
  // {
  //   id: 17,
  //   page: "home_2",
  //   title: "How do I sell Bitcoin on BitPrimax?",
  //   desc: "Selling Bitcoin on BitPrimax is easy. Just navigate to the trading section of the dashboard, select Bitcoin from the list of available cryptocurrencies, and enter the amount you want to sell. You can place a market order to sell Bitcoin at the current market price or set a limit order to sell Bitcoin at a specific price. Once your order is filled, the proceeds from the sale will be credited to your account.",
  // },
  // {
  //   id: 18,
  //   page: "home_2",
  //   title: "What is the BitPrimax staking program?",
  //   desc: "The BitPrimax staking program allows you to earn rewards by holding your cryptocurrencies in your BitPrimax wallet. When you stake your coins, you'll earn a share of the rewards generated by the network. Staking is a great way to earn passive income on your crypto holdings and support the security and stability of the blockchain network.",
  // },
  // {
  //   id: 19,
  //   page: "home_2",
  //   title: "How do I keep my account safe?",
  //   desc: "We recommend enabling two-factor authentication (2FA) for extra security. Always use a unique, strong password and be cautious of phishing attempts. For more tips, check out our security guide.",
  // },
  // {
  //   id: 20,
  //   page: "home_2",
  //   title: "What is a cryptocurrency wallet, and do I need one?",
  //   desc: "A cryptocurrency wallet is a tool that allows you to store, send, and receive digital assets. While you can store your crypto directly on BitPrimax, for added security, we recommend using a personal wallet for long-term storage of your funds.",
  // },
  {
    id: 21,
    page: "home_2",
    title: "Is there a minimum deposit or withdrawal amount?",
    desc: "Yes, there are minimum amounts for both deposits and withdrawals, which may vary depending on the cryptocurrency or payment method used. The minimum withdrwal amount is NGN5,000. Please refer to our trading/withdrawal pages for more information.",
  },
];

export default faq_data;
